import indexOf from 'lodash/indexOf'
import isEmpty from 'lodash/isEmpty'
import { FC, ReactElement, useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'
import { SplitTestsContext } from '@Globals/SplitTests/Context'
import { Group, Test } from '@Globals/SplitTests/types'

type ExperimentProps = Partial<{
  [key in Group]: ReactElement
}> & {
  stores?: string[]
  test: Test
}

export const Experiment: FC<ExperimentProps> = (
  {
    stores,
    test,
    ...elements
  },
) => {
  const { activateSplitTest, observeSplitTest, splitTests } = useContext(SplitTestsContext)
  const { store } = useContext(MetadataContext)

  observeSplitTest(test)

  const activeOnStore = isEmpty(stores) || indexOf(stores, store?.id) !== -1
  const splitTest = splitTests[test]

  if (!splitTest || !activeOnStore) {
    return elements.a || null
  }

  const { group } = splitTest

  activateSplitTest(test, group)

  return elements[group] || null
}
